import React, {Suspense} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {ErrorBoundary} from 'react-error-boundary';
import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import {BrandType} from '@shared/cci/features/const/environment';
import {WebviewUtils} from '@shared/webviewUtils';

function ConsentBannerEu() {
  return (
    <ErrorBoundary fallback={<></>}>
      <Suspense fallback={<></>}>
        <Inner />
      </Suspense>
    </ErrorBoundary>
  );
}

function Inner() {
  const {
    data: {ePrivacySupported, serviceListAllEnabled},
  } = useSuspenseQuery({
    queryKey: [getQueryKey(ccWebviewUtils.getVehicleServiceList)],
    queryFn: () => ccWebviewUtils.getVehicleServiceList(),
  });
  if (serviceListAllEnabled) {
    return <></>;
  }
  if (ePrivacySupported) {
    return <ConsentBannerSupportedEu />;
  }
  return <ConsentBannerNotSupportedEu />;
}

function ConsentBannerSupportedEu() {
  const {t} = useInferableTranslation();
  const brand = import.meta.env.VITE_BRAND;
  return (
    <div className="guide_banner type_guide02">
      <span className="ic ic_filled_caution_16px" />
      <p className="guide_banner_title">{t('msg_dss_LN_service_currently_unavailable')}</p>
      <p className="guide_banner_desc">
        {t('msg_dss_LN_check_infotainment_system', {
          serviceName: brand === BrandType.KIA ? 'Kia Connect' : brand === BrandType.HYUNDAI ? 'Bluelink' : 'Genesis Connected Service',
        })}
      </p>
    </div>
  );
}

function ConsentBannerNotSupportedEu() {
  const {t} = useInferableTranslation();

  function linkToAppSettings() {
    WebviewUtils.close('app://serviceList');
  }

  return (
    <div className="guide_banner type_guide02">
      <span
        className="ic ic_filled_caution_16px"
        aria-hidden="true"
      />
      <p className="guide_banner_title">{t('msg_dss_LN_service_currently_unavailable')}</p>

      <button
        type="button"
        className="btn_hyperlink"
        onClick={() => linkToAppSettings()}
      >
        {t('msg_dss_LN_go_to_settings')}
        <span
          className="ic ic_arrow_forward_12px"
          aria-hidden="true"
        />
      </button>
    </div>
  );
}

export default ConsentBannerEu;
